<div class="search-results-count-container" id="active-vehicles-count" aria-hidden="false">
  <h2 id="manage_inventory_active_vehicles_count" class="mb-0">
    {{ count() | number: '1.0-0' }} {{ resultText() }}@if (count() > 1 || count() === 0) {
    <span>s</span>
  }
</h2>
<div class="search-results-divider"></div>
</div>
